module.exports = __webpack_public_path__ + "static/media/brg.4f0d6b78.svg";